module.exports = __webpack_public_path__ + "static/img/userIcon.06c5cb6b.png";